import { Injectable } from '@angular/core';
import { CookieStorage } from './../../models/cookie-storage.model';
import { LocalStorage } from './../../models/local-storage.model';
import { Storage } from '../../interfaces/storage.interface';
import { isDef } from '../../utils';

@Injectable()
export class DataService {
  activeStorage: Storage;

  constructor() {
    this.activeStorage = this.checkStorage();
  };

  checkStorage(): Storage {
    return isDef(localStorage) ? new LocalStorage() : new CookieStorage();
  }

  getItem(key: string): any {
    return this.activeStorage.getItem(key);
  }

  setItem(key: string, value: any): void {
    this.activeStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    this.activeStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/data.service.ts